import { useState, useEffect } from "react";

const OFFERS = [
  { casino: "5Gringos", bonus: "500% up to £500 + 200 Free Spins", affiliate: "https://fgrns.lynmonkel.com/?mid=389405_2246229", color: "#f59e0b" },
  { casino: "HellSpin", bonus: "CA$5,200 + 150 Free Spins", affiliate: "https://top.aglobally.com/redirect.aspx?pid=4960&bid=1466&lpid=6", color: "#ef4444" },
  { casino: "LeoVegas", bonus: "$1,000 + 200 Free Spins", affiliate: "https://ntrfr.leovegas.com/redirect.aspx?pid=3658838&bid=18372", color: "#f97316" },
  { casino: "Vulkan Vegas", bonus: "CA$1,500 + 150 Free Spins", affiliate: "https://vulkanvegas-promo.com/l/69b09766a52f4256800c1002", color: "#a855f7" },
];

export default function ExitIntentPopup() {
  const [visible, setVisible] = useState(false);
  const [offer] = useState(() => OFFERS[Math.floor(Math.random() * OFFERS.length)]);
  const [timeLeft, setTimeLeft] = useState(600);

  useEffect(() => {
    const shown = sessionStorage.getItem("exitShown");
    if (shown) return;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 5) {
        setVisible(true);
        sessionStorage.setItem("exitShown", "1");
        document.removeEventListener("mouseleave", handleMouseLeave);
      }
    };

    // Mobile: show after 45 seconds of inactivity
    let mobileTimer;
    if (window.innerWidth < 768) {
      mobileTimer = setTimeout(() => {
        if (!sessionStorage.getItem("exitShown")) {
          setVisible(true);
          sessionStorage.setItem("exitShown", "1");
        }
      }, 45000);
    }

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
      clearTimeout(mobileTimer);
    };
  }, []);

  useEffect(() => {
    if (!visible) return;
    const t = setInterval(() => setTimeLeft(p => p > 0 ? p-1 : 0), 1000);
    return () => clearInterval(t);
  }, [visible]);

  if (!visible) return null;

  const mins = String(Math.floor(timeLeft/60)).padStart(2,"0");
  const secs = String(timeLeft%60).padStart(2,"0");

  return (
    <div style={{position:"fixed",inset:0,zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.88)",backdropFilter:"blur(6px)"}}
      onClick={(e) => e.target === e.currentTarget && setVisible(false)}>
      <div style={{background:"linear-gradient(135deg,#1a0533,#2d0a5e)",border:"2px solid rgba(168,85,247,0.4)",borderRadius:"24px",padding:"40px 32px",maxWidth:"460px",width:"90%",textAlign:"center",position:"relative",boxShadow:"0 0 80px rgba(168,85,247,0.25)"}}>
        
        {/* Close */}
        <button onClick={() => setVisible(false)} style={{position:"absolute",top:"14px",right:"18px",background:"none",border:"none",color:"rgba(255,255,255,0.3)",fontSize:"1.4rem",cursor:"pointer"}}>✕</button>

        {/* Wait badge */}
        <div style={{display:"inline-flex",alignItems:"center",gap:"6px",background:"rgba(239,68,68,0.15)",border:"1px solid rgba(239,68,68,0.4)",borderRadius:"100px",padding:"4px 14px",marginBottom:"16px"}}>
          <span style={{color:"#ef4444",fontSize:"0.75rem",fontWeight:"700"}}>⚠️ WAIT! DON'T LEAVE YET</span>
        </div>

        <h2 style={{color:"white",fontSize:"1.6rem",fontWeight:"bold",marginBottom:"8px",lineHeight:1.2}}>
          You're Missing an<br/><span style={{color:offer.color}}>Exclusive Offer!</span>
        </h2>
        <p style={{color:"rgba(255,255,255,0.5)",fontSize:"0.9rem",marginBottom:"24px"}}>
          This special bonus expires when you leave. Grab it now!
        </p>

        {/* Offer Box */}
        <div style={{background:`${offer.color}15`,border:`2px solid ${offer.color}40`,borderRadius:"16px",padding:"20px",marginBottom:"20px"}}>
          <div style={{color:"rgba(255,255,255,0.5)",fontSize:"0.75rem",marginBottom:"4px"}}>EXCLUSIVE OFFER AT {offer.casino.toUpperCase()}</div>
          <div style={{color:offer.color,fontSize:"1.4rem",fontWeight:"bold"}}>{offer.bonus}</div>
        </div>

        {/* Countdown */}
        <div style={{marginBottom:"20px"}}>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.75rem",marginBottom:"8px"}}>⏱ OFFER EXPIRES IN</div>
          <div style={{display:"flex",justifyContent:"center",gap:"8px"}}>
            {[{v:mins,l:"MIN"},{v:secs,l:"SEC"}].map(({v,l}) => (
              <div key={l} style={{background:"rgba(0,0,0,0.3)",borderRadius:"10px",padding:"10px 16px",minWidth:"60px"}}>
                <div style={{color:"white",fontSize:"1.6rem",fontWeight:"bold",lineHeight:1}}>{v}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"0.65rem"}}>{l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <a href={offer.affiliate} target="_blank" rel="noopener noreferrer" style={{display:"block",textDecoration:"none",marginBottom:"10px"}}>
          <button style={{width:"100%",background:`linear-gradient(135deg,${offer.color},${offer.color}bb)`,color:"black",border:"none",borderRadius:"12px",padding:"16px",fontSize:"1.1rem",fontWeight:"bold",cursor:"pointer"}}>
            🎁 Claim My Bonus Now →
          </button>
        </a>
        <button onClick={() => setVisible(false)} style={{background:"none",border:"none",color:"rgba(255,255,255,0.25)",fontSize:"0.8rem",cursor:"pointer",textDecoration:"underline"}}>
          No thanks, I don't want free bonuses
        </button>

        <div style={{marginTop:"12px",color:"rgba(255,255,255,0.2)",fontSize:"0.7rem"}}>18+ | Gamble Responsibly | T&Cs Apply</div>
      </div>
    </div>
  );
}
